import React from "react"
import {
  DrawerBox,
  DrawerBoxHeading,
  Heading,
  TypoHeading,
  ModalHeadingRow,
  HeadingTypoTable,
  HeadingTypoTableTwo,
  MetricContainer,
  MetricContainerOne,
  MetricContainerTwo,
  MetricContainerThree,
  ActiveIcon,
  WatchIcon,
  AchivedIcon,
  MissedIcon,
  StarIcon,
  HeadingTypoTableThree,
} from "./Atom"
import {
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import { useSelector } from "react-redux"
import BasicMenu from "../../../Menu/OpportunityStatusMenu"
import { roundUp } from "../../../../../helper/utils/formatting"
import { colors } from "../../../../../styles/commonStyles"

function OpportunityDetails(props: any) {
  const details = useSelector((state: any) => {
    return state.metric.opportunityMoreColumns
  })
  const { opportunityName, officeName, row, updateStatus } = props

  const opportunityFetchId = useSelector((state: any) => {
    return state.metric.opportunityFetchId
  })
  const opportunityStatus = useSelector((state: any) => {
    return state.metric.opportunityStatus
  })

  const opportunitySelectedStatus = useSelector((state: any) => {
    return state.metric.opportunitySelectedStatus
  })
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  })

  return (
    <>
      <Box>
        <Heading>
          <Typography sx={{ color: "#3C77EF", width: "40%" }}>
            {opportunityName}
          </Typography>
          <TypoHeading
            sx={{
              width: "30%",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {officeName}
          </TypoHeading>
          <Box
            sx={{
              width: "30%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              {opportunityStatus === "active" ? (
                <ActiveIcon />
              ) : opportunityStatus === "achieved" ? (
                <AchivedIcon />
              ) : opportunityStatus === "missed" ? (
                <MissedIcon />
              ) : (
                ""
              )}
            </span>

            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "bold",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textTransform: "uppercase",
                color:
                  opportunityStatus === "active"
                    ? "#3366D6"
                    : opportunityStatus === "achieved"
                    ? "#42B2A0"
                    : opportunityStatus === "missed"
                    ? "#F15854"
                    : "",
              }}
            >
              {opportunityStatus}
            </Typography>
            {opportunityStatus === "active" ? (
              <BasicMenu
                valueToApply={opportunityStatus}
                opportunityFetchId={opportunityFetchId}
                row={row}
                updateStatus={updateStatus}
              />
            ) : (
              ""
            )}
          </Box>
          {/* <Typography sx={{ padding: "20px" }}>{opportunityStatus}</Typography> */}
        </Heading>
      </Box>
      <ModalHeadingRow>
        <HeadingTypoTable>KPI</HeadingTypoTable>
        <HeadingTypoTableTwo>Start Value</HeadingTypoTableTwo>
        <HeadingTypoTableThree>Current Value</HeadingTypoTableThree>
      </ModalHeadingRow>

      {details?.map((ele: any, ind: any) => {
        return (
          <>
            <MetricContainer>
              <MetricContainerOne>
                {ele.is_target_column === true ? (
                  <>
                    {ele.column_id.replace(/_+/g, " ")} <StarIcon />
                  </>
                ) : (
                  ele.column_id.replace(/_+/g, " ")
                )}
              </MetricContainerOne>
              <MetricContainerTwo>
                <Box
                  sx={{
                    backgroundColor:
                      ele.column_color === null
                        ? ""
                        : ele.column_color.toLowerCase() === "red"
                        ? colors.primaryRed
                        : ele.column_color.toLowerCase() === "green"
                        ? colors.primaryGreen
                        : ele.column_color.toLowerCase() === "yellow"
                        ? colors.primaryYellow
                        : "",
                    color:
                      ele.column_color === null
                        ? ""
                        : ele.column_color.toLowerCase() === "red"
                        ? colors.primaryWhite
                        : ele.column_color.toLowerCase() === "green"
                        ? colors.primaryWhite
                        : ele.column_color.toLowerCase() === "yellow"
                        ? colors.primaryBlack
                        : "",

                    width: "115px",
                    height: "70%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {ele.column_value === null ? (
                    "N/A"
                  ) : (
                    <>
                      {roundUp(
                        ele.column_value,
                        ele.column_data_type,
                        ele?.metric_precision,
                      )}
                    </>
                  )}
                </Box>
              </MetricContainerTwo>
              <MetricContainerThree>
                <Box
                  sx={{
                    backgroundColor:
                      ele.column_current_color === null
                        ? ""
                        : ele.column_current_color.toLowerCase() === "red"
                        ? colors.primaryRed
                        : ele.column_current_color.toLowerCase() === "green"
                        ? colors.primaryGreen
                        : ele.column_current_color.toLowerCase() === "yellow"
                        ? colors.primaryYellow
                        : "",
                    color:
                      ele.column_current_color === null
                        ? ""
                        : ele.column_current_color.toLowerCase() === "red"
                        ? colors.primaryWhite
                        : ele.column_current_color.toLowerCase() === "green"
                        ? colors.primaryWhite
                        : ele.column_current_color.toLowerCase() === "yellow"
                        ? colors.primaryBlack
                        : "",
                    width: "115px",
                    height: "70%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {ele.column_current_value === null ? (
                    "N/A"
                  ) : (
                    <>
                      {roundUp(
                        ele.column_current_value,
                        ele.column_data_type,
                        ele?.metric_precision,
                      )}
                    </>
                  )}
                </Box>
              </MetricContainerThree>
            </MetricContainer>
            <Divider />
          </>
        )
      })}
    </>
  )
}

export default OpportunityDetails
